export default {
    env: process.env.NODE_ENV,
    apiBaseUrl: process.env.API_BASE_URL,
    baseUrl: process.env.BASEURL,
    adminPath: 'app',
    lang: 'th'
};

export const PerPage = () => {
    return [10, 25, 50, 100, 250, 500];
};

export const timeZonelist = () => {
    return {
        "value": "SE Asia Standard Time",
        "abbr": "SAST",
        "offset": 7,
        "isdst": false,
        "text": "(UTC+07:00) Bangkok, Hanoi, Jakarta",
        "timezone": "Asia/Bangkok"
    };
};

export const formatDateTime = () => {
    return 'YYYY-MM-DD HH:mm';
};

export const dateFormatMoment = () => {
    return 'YYYY-MM-DD';
}
export const showTextPicker = (dateRange) => {
    if (dateRange.startDate && dateRange.endDate) {
        return moment(dateRange.startDate).utc().format(dateFormatMoment()) + ' - ' + moment(dateRange.endDate).utc().format(dateFormatMoment());
    } else {
        return 'Select Date';
    }
}

export const _componentPopoverCustomHeaderColor = function () {
    $("[data-popup=popover-custom]").popover({
      template:
        '<div class="popover border-light"><div class="arrow"></div><p class="popover-header bg-light font-weight-bold"></p><div class="popover-body"></div></div>',
    });
};
  
export const _componentPopoverF7F7F8HeaderColor = () => {
    $('[data-popup=popover-suggestion]').popover({
        template: '<div class="popover border-ddd text-515151"><div class="arrow"></div><p class="popover-header bg-light bg-F7F7F8 font-weight-bold text-515151 font-15 pb-2"></p><div class="popover-body text-515151 font-13"></div></div>'
    });
};

export const trimStringStartandEnd = (str) => {
    if (!str) {
        return str;
    } else {
        return str.replace(/^\s+|\s+$/g, '');
    }
}



// WEBPACK FOOTER //
// ./src/configure/index.js